/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { get } from 'lodash'

/**
 *     Import
 *     - Components
 */
import Container from '../../../common/Container/Container'
import HeaderContainer from '../../../common/HeaderContainer/HeaderContainer'
import Accordion from '../../../common/Accordion/Accordion'
import Loading from '../../../common/Loading/Loading'

import Step00View from './components/Step00View'
import Step01 from '../../../../containers/pages/Quote/Step01'
import Step02 from '../../../../containers/pages/Quote/Step02'
import Step03 from '../../../../containers/pages/Quote/Step03'
import Step03c from './containers/Step03c'
import Step04 from '../../../../containers/pages/Quote/Step04'
// import Step04c from '../../../../containers/pages/Quote/Step04c'
import Step04c from './containers/Step04c'
import Step05 from '../../../../containers/pages/Quote/Step05'
import Step05c from '../../../../containers/pages/Quote/Step05c'

import { setStep04c, getQuoteVariation } from '../../../../actions'

/**
 *     Import
 *     - Styles
 */
import '../styles/Quote.css'

export default class EditQuote extends React.Component<any, any> {

    constructor(props: any) {
        super(props)

        this.state = {
            dirtyAccordion: {
                step01: false,
                step02: false,
                step03: false,
                step03c: false,
                step04: false,
            },
            values: null,
            checkstep02or03: false,
            checkstep02: false,
            checkstep04: false,
        }
    }

    componentDidMount() {
        this.triggerUpdate()
    }

    componentDidUpdate(prevProps: any, nextProps: any) {
        let getEditValuesQuotes = get(this.props.quote.full.response, 'quote')
        // quote.full.response.quote.commercialInsurancePolicyCancelled
        // get (getEditValuesQuotes,'commercialInsurancePolicyCancelled')
        if (this.state.values === null && getEditValuesQuotes) {
            this.setState({
                values: {
                    commercialInsurancePolicyCancelled: getEditValuesQuotes.commercialInsurancePolicyCancelled,
                    criminalConvictionsOrCautions: getEditValuesQuotes.criminalConvictionsOrCautions,
                    declaredBankruptOrInsolvent: getEditValuesQuotes.declaredBankruptOrInsolvent,
                    entrustOthersAndAgreesResponsibleForInsurance:
                        getEditValuesQuotes.entrustOthersAndAgreesResponsibleForInsurance,
                    entrustedItemsAndAgreesAmountEventLoss: getEditValuesQuotes.entrustedItemsAndAgreesAmountEventLoss,
                    intendClaims: getEditValuesQuotes.intendClaims,
                    intendClaimsDescription: getEditValuesQuotes.intendClaimsDescription,
                    isCollectors: getEditValuesQuotes.isCollectors,
                    keepsRecordInDurableFormat: getEditValuesQuotes.keepsRecordInDurableFormat,
                    madeClaims: getEditValuesQuotes.madeClaims,
                    // madeClaimsArray: getEditValuesQuotes.madeClaimsArray,
                    proposalOrRenewalRefusedOrDeclined: getEditValuesQuotes.proposalOrRenewalRefusedOrDeclined,
                    prosecutionsPending: getEditValuesQuotes.prosecutionsPending,
                    regularStockTaking: getEditValuesQuotes.regularStockTaking,
                    specialTermsImposed: getEditValuesQuotes.specialTermsImposed,
                    subjectCourtJudgmentDebt: getEditValuesQuotes.subjectCourtJudgmentDebt,
                    turnover: getEditValuesQuotes.turnover,
                },
            })
        }
        let loc = get(prevProps.quote.riskLocations, 'response')

        if (loc && loc.length === 1 && this.state.checkstep02) {
            this.setState({
                checkstep02or03: false,
                checkstep02: false,
            })
        }
        let getpropsLocations = get(this.props.quote, 'riskLocations')
        if (getpropsLocations && getpropsLocations.loading === false && getpropsLocations.response.length === 1
            && this.state.checkstep02 && getEditValuesQuotes.riskLocations !== getpropsLocations.response) {
            let sumPrints: any = (getEditValuesQuotes) ? this._calculateSum(
                getEditValuesQuotes.stockBusinessAssets.agreedItems,
                getEditValuesQuotes.stockBusinessAssets.unspecifiedItems) : '0'
            let cl: any = []
            getpropsLocations.response.map((el) => {
                let cltemp = {
                    'id': el.id,
                    'allocated':
                        Number(sumPrints).toFixed(2),
                }
                cl.push(cltemp)
            })
            let content = {
                'quote': {
                    'id': this.props.match.params.id,
                    'collections_locations': cl,
                },
            }
            setStep04c(content)
            getQuoteVariation(this.props.match.params.id)
            this.props.getFullQuote(this.props.match.params.id)
        }
    }

    triggerUpdate = () => {
        this.props.getFullQuote(this.props.match.params.id)
    }

    updateDirty = (dirtyItem, dirtyState) => {
        let loc = get(this.props.quote.riskLocations, 'response')
        if (this.state.dirtyAccordion[dirtyItem] !== dirtyState) {
            this.setState({
                dirtyAccordion: {
                    ...this.state.dirtyAccordion,
                    [dirtyItem]: dirtyState,
                },
            })
            if (dirtyItem === 'step04') {
                this.setState({ checkstep02or03: true, checkstep04: true })
            }
            if (dirtyItem === 'step03c') {
                this.setState({ checkstep02or03: (loc && loc.length === 1) ? true : false })
            }
            if (dirtyItem === 'step03') {
                this.setState({ checkstep02or03: true })
            }
            if (dirtyItem === 'step02') {
                this.setState({ checkstep02or03: false, checkstep02: true })
                this.triggerUpdate()
            }
            // if (loc && loc.length === 1) {
            //     let cl: any = []
            //     loc.map((el) => {
            //         let cltemp = {
            //             'id': el.id,
            //             'allocated': Number(el.allocated).toFixed(2),
            //         }
            //         cl.push(cltemp)
            //     })
            //     let content = {
            //         'quote': {
            //             'id': this.props.match.params.id,
            //             'collections_locations': cl,
            //         },
            //     }
            //     setStep04c(content)
            //     getQuoteVariation(this.props.match.params.id)
            //     this.props.getFullQuote(this.props.match.params.id)
            // }
        }
    }
    checkUpdate = () => {
        this.triggerUpdate()
        this.setState({ checkstep02or03: true })
    }

    _calculateSum = (agreedItems, unspecifiedItems) => {
        let total = 0
        if (agreedItems && Object.values(agreedItems).length) {
            Object.values(agreedItems).map((agreedType) => {
                Object.values(agreedType).map((s) => {
                    total += parseFloat(s.insured)
                })
            })
        }
        if (unspecifiedItems && Object.values(unspecifiedItems).length) {
            Object.values(unspecifiedItems).map((u: any) => {
                total += parseFloat(u)
            })
        }
        // return Number(total).toFixed(2)
        return Number(total)
    }

    render() {

        let { response, loading, done } = this.props.quote.full
        let isCollectors = get(response, 'quote.isCollectors')
        return (
            <div className="quote quote--edit">

                <HeaderContainer
                    className="quote__header"
                    fullwidth={false}
                    pretitle={(isCollectors) ? 'Collections Policy' : 'Commercial Art Insurance'}
                    titles={['Edit Quote']}
                />

                <Container className="quote__edit container__wider" fullwidth={false}>
                    <div className="quote__edit__infoblock">

                        <Accordion title="Client Details">
                            {(!loading && done) ? (
                                <Step00View values={response} />
                            ) : <Loading />}
                        </Accordion>

                        <Accordion title="Policy Details">
                            {(!loading && done) ? (
                                <Step01
                                    data={response}
                                    values={(this.state.values !== null) ? this.state.values : null}
                                    editQuote={true}
                                    match={this.props.match}
                                    update={this.triggerUpdate}
                                    updateDirty={(value) => this.updateDirty('step01', value)}
                                />
                            ) : <Loading />}
                        </Accordion>

                        <Accordion title="Risk Address">
                            <Step02
                                editQuote={true}
                                match={this.props.match}
                                isCollectors={isCollectors}
                                isEditQuote={true}
                                updateDirty={(value) => this.updateDirty('step02', value)}
                            />
                        </Accordion>

                        {/* <Accordion title="Add Stock & Business Assets">
                            {(!loading && done) ? (
                                (isCollectors) ? <Step03c
                                    data={get(response, 'quote.stockBusinessAssets')}
                                    editQuote={true}
                                    match={this.props.match}
                                    update={this.triggerUpdate}
                                    updateDirty={(value) => this.updateDirty('step03', value)}
                                /> :
                                    <Step03
                                        data={response.quote.stockBusinessAssets}
                                        editQuote={true}
                                        match={this.props.match}
                                        update={this.triggerUpdate}
                                        updateDirty={(value) => this.updateDirty('step03', value)}
                                    />
                            ) : <Loading />}
                        </Accordion> */}
                        {(!isCollectors) ? <Accordion title="Add Stock & Business Assets">
                            {(!loading && done) ?
                                <Step03
                                    data={response.quote.stockBusinessAssets}
                                    editQuote={true}
                                    match={this.props.match}
                                    update={this.triggerUpdate}
                                    updateDirty={(value) => this.updateDirty('step03', value)}
                                />
                                : <Loading />}
                        </Accordion> : <Accordion title="Collection Assets">
                                {(!loading && done) ?
                                    <Step03c
                                        data={response.quote.stockBusinessAssets}
                                        editQuote={true}
                                        match={this.props.match}
                                        update={this.triggerUpdate}
                                        mta={false}
                                        updateDirty={(value) => this.updateDirty('step03c', value)}
                                    />
                                    : <Loading />}
                            </Accordion>}

                        <Accordion title={(isCollectors) ? 'Collections Locations' : 'Additional Cover'}>
                            {(!loading && done) ? (
                                (isCollectors) ? <Step04c
                                    data={response.quote.additionalCover}
                                    editQuote={true}
                                    match={this.props.match}
                                    updateDirty={(value) => this.updateDirty('step04', value)}
                                    // update={this.triggerUpdate}
                                    getFullquoteId={this.props.match.params.id}
                                /> :
                                    <Step04
                                        data={response.quote.additionalCover}
                                        editQuote={true}
                                        match={this.props.match}
                                        updateDirty={(value) => this.updateDirty('step04', value)}
                                        update={this.triggerUpdate}
                                    />
                            ) : <Loading />}
                        </Accordion>

                        <Accordion title="Quote Preview">
                            {(!loading && done) ? (
                                (isCollectors) ? <Step05c
                                    data={response.quote}
                                    editQuote={true}
                                    editQuotes={true}
                                    match={this.props.match}
                                    checkUpdate={this.checkUpdate}
                                    dirtySteps={(this.state.checkstep02or03) ? false : true}
                                /> :
                                    <Step05
                                        data={response.quote}
                                        editQuote={true}
                                        match={this.props.match}
                                        // dirtySteps={
                                        //     !Object.values(this.state.dirtyAccordion).every(
                                        //         val => (val === false)
                                        //     )
                                        // }
                                        dirtySteps={(this.state.checkstep02or03) ? false : true}
                                    />
                            ) : <Loading />}
                        </Accordion>

                    </div>
                </Container>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/EditQuote/EditQuote.tsx